
<template>
    <div class="story" :style="{ width: resolution + 'px' }">
        <StoryMaker
            v-if="formData"
            :formData="formData"
            :idStorySelected="Object.keys(formData.storification)[0]"
            :pageSelected="page"
            :previewEnabled="true"
            :files="files"
        />
    </div>
</template>

<script>
    import StoryMaker from '../dash/postCreator/StoryMaker.vue';
    export default {
        components: {
            StoryMaker,
        },
        data() {
            return {
                formData : null,
                page: null,
                files: {},
                resolution: 1080
            }
        },
    
        created () {
            if (localStorage.storificationPreviewData) {
                const storificationPreviewData = JSON.parse(localStorage.storificationPreviewData)

                this.files = storificationPreviewData.files
                this.formData = {
                    storification: storificationPreviewData.storification
                }
                this.page = storificationPreviewData.page
                this.resolution= storificationPreviewData.resolution
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>